module.exports = __webpack_public_path__ + "static/media/V2_Astrael---Fotografie---Astrael---2019-2.13ade86e.jpg";